
        <ion-scroll scrollY="true" zoom="false" style="height:100%">
            <ng-content></ng-content>
        </ion-scroll>
    